export default __webpack_public_path__ + "static/media/20.98b6e3ce.png";